<template>
  <b-form @submit.stop.prevent="validateWhenSubmit" novalidate="novalidate" autocomplete="off">
    <div class="row">
      <div class="col-12">
        <div class="form-group bmd-form-group">
          <label>
            <strong>Cliente:</strong>
            {{ proposal.client.name }}
          </label>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Tel. Celular:</strong>
          </label>
          <label>
              {{ proposal.client.cell_phone | phone }}
              <a :href="'https://wa.me/55' + proposal.client.cell_phone" target="_blank" class="whatsapp-link">
                <img src="../../assets/whatsapp.png" />
                </a>
          </label>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Tel. Residencial:</strong>
          </label>
          <label>{{ proposal.client.home_phone | phone }}</label>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Tel. Comercial:</strong>
          </label>
          <label>{{ proposal.client.commercial_phone | phone }}</label>
        </div>
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Bem:</strong>
          </label>
          <label
            v-if="proposal.model"
          >{{ proposal.model.manufacturer.name }} / {{ proposal.model.name }}</label>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Proposta:</strong>
          </label>
          <label>{{ proposal.id }} / {{ proposal.salesman.name }}</label>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Informações da Parcela:</strong>
          </label>
          <label
            v-if="installment"
          >{{ installment.price | price }} - {{ installment.due_at | moment('DD/MM/YYYY') }}</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div
          class="form-group bmd-form-group"
          v-bind:class="{'is-filled': !!form.next_contact, 'has-danger': !!errors.first('next_contact') }"
        >
          <el-date-picker
            class="w-100"
            v-model="form.next_contact"
            v-validate="formValidations.next_contact"
            data-vv-name="next_contact"
            type="datetime"
            format="dd/MM/yyyy HH:mm:ss"
            value-format="yyyy/MM/dd HH:mm:ss"
            placeholder="Data do próximo contato"
          ></el-date-picker>

          <label
            v-if="!!errors.first('next_contact')"
            class="error"
            for="name"
          >{{ errors.first('next_contact') }}</label>
        </div>
      </div>

      <div class="col-12">
        <div
          class="form-group bmd-form-group"
          :class="{'is-filled': !!form.text, 'has-danger': !!errors.first('text') }"
        >
          <label for="text">Observação</label>
          <b-form-textarea
            data-vv-name="text"
            v-validate="formValidations.text"
            id="text"
            v-model="form.text"
            placeholder="Informe aqui a observação"
          ></b-form-textarea>
          <label v-if="!!errors.first('text')" class="error" for="name">{{ errors.first('text') }}</label>
        </div>
      </div>
    </div>

    <b-button :disabled="loading" type="submit" variant="primary">Salvar</b-button>
  </b-form>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new" // give me my own validator scope.
  },
  computed: {
    installment: {
      set(installment) {},
      get() {
        return this.$store.state.charges.item.data;
      }
    },
    proposal: {
      set(proposal) {},
      get() {
        return this.$store.state.proposals.item;
      }
    }
  },
  data() {
    return {
      loading: false,
      formValidations: {
        next_contact: {
          required: true
        },
        text: {
          required: true
        }
      },
      form: {
        next_contact: "",
        text: ""
      }
    };
  },
  created() {
    this.getProposal();
  },
  methods: {
    async getProposal() {
      this.$root.$emit("onLoading");

      const installment = await this.$store.dispatch(
        "charges/get",
        this.$route.params.id
      );

      const response = await this.$store.dispatch(
        "proposals/get",
        installment.data.proposal_id
      );

      this.$root.$emit("onLoading");

      this.form.proposal_id = installment.data.proposal_id;
      this.form.installment_id = installment.data.id;
    },
    validateWhenSubmit() {
      this.$validator.validateAll().then(isValid => {
        this.loading = false;
        if (isValid) {
          this.saveContact();
          return;
        }
      });
    },
    async saveContact() {
      this.loading = true;
      this.$root.$emit("onLoading");

      const response = await this.$store.dispatch(
        "charges/contacts",
        this.form
      );

      this.loading = false;
      this.$root.$emit("updateList");
      this.$root.$emit("hideModal");
      this.$notify.success(response.message);
      this.$root.$emit("onLoading");
    }
  }
};
</script>

<style scoped>
    .whatsapp-link img {
        width: 24px;
        height: 24px;
    }
</style>
